import React from "react";

const SearchInput = ({ loc, handleOnChange }) => {
  return (
    <input
      type="text"
      className="inputS"
      placeholder={"Search " + loc.pathname.replace("/", "") + "....."}
      onChange={handleOnChange}
    />
  );
};

export default SearchInput;
